import { render } from "./CreateVideoFeatureModal.vue?vue&type=template&id=623f73d9"
import script from "./CreateVideoFeatureModal.vue?vue&type=script&lang=js"
export * from "./CreateVideoFeatureModal.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "623f73d9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('623f73d9', script)) {
    api.reload('623f73d9', script)
  }
  
  module.hot.accept("./CreateVideoFeatureModal.vue?vue&type=template&id=623f73d9", () => {
    api.rerender('623f73d9', render)
  })

}

script.__file = "resources/js/Pages/Station/Partials/Features/Video/CreateVideoFeatureModal.vue"

export default script